import { ReactNode } from 'react'

import './liveInfo.scss'

export interface Props {
  title: ReactNode,
  description: ReactNode
}

const LiveInfo = ({ title, description }: Props) => {
  return (
    <div className="live-info">
      <header>{title}</header>
      <p className="description">{description}</p>
    </div>
  )
}

export default LiveInfo
